<template>
<div id="maintenanceList">
	<Confirm ref="confirm" @confirm="del"></Confirm>
	<ViewDetail ref="ViewDetail" @confirmDel="confirmDel" @refreshList="getList()"></ViewDetail>
	<div class="table table-5x posR" fillHeight="lastHeight,-space">
		<Loading ref="Loading"></Loading>
		<div v-show="list!=null && pagination.total>0" class="tableScope cb">
			<div class="scrollHide tra-fast fL" :style="{'width':stage.setting.system.autoColumnWidth[0]*floatColumn.length*.7+stage.setting.system.autoColumnWidth[1]}"
				 scrollFloatX="false">
				<div class="tableSys head noSelect cField bdLight-bottom tra-fast_E" scrollFloatY="false">
					<div>{{getLanguageStr('app3','名称')}}</div>
				</div>
				<div class="fixedScrollBar scrollY tra-fast" fillHeight="lastHeight,-#maintenanceList .tableBatch,-space" scroll="{'group':'a'}">
					<table>
						<thead class="head-token">
						<tr>
							<th></th>
						</tr>
						</thead>
						<tbody class="bdLight-bottom_E emptyToken_EE textCut_EE">
						<tr v-for="(item,index) in list" :key="index">
							<td :title="item.name||''" class="textCut curP" permission-type="none" v-permissions="'C/A/A5'" @click.stop="clickfount(item)">{{item.name}}</td>
						</tr>
						</tbody>
					</table>
				</div>
			</div>
			<div class="operate scrollHide" :mode="stage.setting.loc.operateMode">
				<div class="tableSys head noSelect b cField bdLight-bottom bgContent tra-fast_E" scrollFloatY="false">
					<div class="cb vaM_E">
						<button class="fa fa-angle-double-right hover-c-main" :title="$t('cmd108',['点击展开/收起'])" @click="operateModeChange" type="button"></button>
						<span class="dpIB lh20" :title="$t('word47',['操作'])">{{$t("word47",["操作"])}}</span>
					</div>
				</div>
				<div class="fixedScrollBar scrollY tra-fast bgContent" fillHeight="lastHeight,-#maintenanceList .tableBatch,-space" scroll="{'group':'a'}">
					<table>
						<thead class="head-token">
							<tr>
								<th></th>
							</tr>
						</thead>
						<tbody class="bdLight-bottom_E textCut_EE">
							<tr v-for="(item,index) in list" :key="index">
								<td class="cSub fSub w3x_E mr05x_E hover-c-main_E tra-fast_E vaM_E">
									<button class="hover-f-main fs12x" type="button" :title="$t('cmd8',['编辑'])" @click="edit(item)" permission-type="none" v-permissions="'C/A/A7'">
										<Icon name="ico-edit-o" class="w1x h1x"/>
									</button>
									<button class="hover-c-error hover-f-error fs12x" type="button" @click="confirmDel(item.id)" :title="$t('cmd9',['删除'])" permission-type="none" v-permissions="'C/A/A6'">
										<Icon name="ico-recycle" class="w1x h1x "/>
									</button>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
			<div scroll="{'axis':'x'}">
				<div class="tableSys head noSelect b cField bdLight-bottom"
					:style="{'min-width':stage.setting.system.autoColumnWidth[0]*column.length+stage.setting.system.autoColumnWidth[1]}" scrollFloatY="false">
					<div>{{getLanguageStr('plant233','维保人')}}</div>
					<div>{{getLanguageStr('word2003','维保时间')}}</div>
					<div>{{getLanguageStr('word1998','维保系统类型')}}</div>
					<div>{{getLanguageStr('word1999','维保系统')}}</div>
					<div>{{getLanguageStr('word2000','维保对象类型')}}</div>
					<div>{{getLanguageStr('word2001','维保对象')}}</div>
					<div>{{getLanguageStr('word774','管理者')}}</div>
					<div :class="{cMain:orderBy=='createdDate'}" class="sequence" :title="getLanguageStr('app2','创建时间')" @click="onOrder('createdDate',orderDirection)">
						<span>{{getLanguageStr('app2','创建时间')}}</span>
						<span :sequence="orderBy=='createdDate'? orderDirection:''"></span>
					</div>
					<div :class="{cMain:orderBy=='lastModifiedDate'}" class="sequence" :title="getLanguageStr('app32','更新时间')" @click="onOrder('lastModifiedDate',orderDirection)">
						<span>{{getLanguageStr('app32','更新时间')}}</span>
						<span :sequence="orderBy=='lastModifiedDate'? orderDirection:''"></span>
					</div>
				</div>
				<div class="fixedScrollBar scrollY tra-fast" fillHeight="lastHeight,-#maintenanceList .tableBatch,-space" scroll="{'group':'a'}">
					<table :style="{'min-width':stage.setting.system.autoColumnWidth[0]*column.length+stage.setting.system.autoColumnWidth[1]}">
						<thead class="head-token">
							<tr>
								<th></th>
								<th></th>
								<th></th>
								<th></th>
								<th></th>
								<th></th>
								<th></th>
								<th></th>
								<th></th>
							</tr>
						</thead>
						<tbody class="bdLight-bottom_E emptyToken_EE textCut_EE">
							<tr v-for="(item,index) in list" :key="index">
								<td :title="item.personNames?item.personNames:'--'">
									<span v-if="item.personNames.length>0">{{item.personNames[0]}}{{$t('fill3rd183',[item.personNames.length,`等${item.personNames.length}人`])}}</span>
									<span v-else>--</span>
								</td>
								<td :title="timeFormat(item.time,'system','%Y/%m/%d %H:%M')">
										<div>{{item.time?timeFormat(item.time,'system','%H:%M'):'--'}}</div>
													<div class="cSub">{{item.time?timeFormat(item.time,'system','%Y/%m/%d UTC'):'--'}}</div>
								</td>
								<td>{{item.systemType?getTypeText(item.systemType,'maintenanceSystem'):''}}</td>
								<td>{{item.systemTypeName}}</td>
								<td>{{item.objectType?getTypeText(item.objectType,'maintenanceObject'):''}}</td>
								<td>
									<div v-if="item.objectType==1" class="dpIB" :title="item.deviceDetailList?item.deviceDetailList[0].name?item.deviceDetailList[0].name:getTypeText(item.deviceDetailList[0].type,'deviceType')+item.deviceDetailList[0].serialNumber+$t('app6',[item.deviceDetailList.length,`等${item.deviceDetailList.length}个设备`]):'--'"> 
										<span v-if="item.deviceDetailList&&item.deviceDetailList.length>0" >
															 {{item.deviceDetailList[0].name?item.deviceDetailList[0].name+item.deviceDetailList[0].serialNumber:getTypeText(item.deviceDetailList[0].type,'deviceType')+item.deviceDetailList[0].serialNumber}}{{$t('app6',[item.deviceDetailList.length,`等${item.deviceDetailList.length}个设备`])}}
											</span>
										<span v-else>--</span>
									</div>
									<span v-else :title="item.objectNameList[0]" class="dpIB textCut">{{item.objectNameList[0]}}</span>
								</td>
								<td>{{item.createdByName}}</td>
								<td :title="timeFormat(item.createdDate,'system','%Y/%m/%d %H:%M')">
										<div>{{item.createdDate?timeFormat(item.createdDate,'system','%H:%M'):'--'}}</div>
													<div class="cSub">{{item.createdDate?timeFormat(item.createdDate,'system','%Y/%m/%d UTC'):'--'}}</div>
								</td>
								<td :title="timeFormat(item.lastModifiedDate,'system','%Y/%m/%d %H:%M')">
									<div>{{item.lastModifiedDate?timeFormat(item.lastModifiedDate,'system','%H:%M'):'--'}}</div>
													<div class="cSub">{{item.lastModifiedDate?timeFormat(item.lastModifiedDate,'system','%Y/%m/%d UTC'):'--'}}</div>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
			<div class="tableBatch bgContent cSub boxR-bottom" :class="{disable:!list}">
				 <Pagination :pagination="pagination" :getList="getList" ref="Pagination"></Pagination>
			</div>
		</div>
			<no-result v-if="!list"></no-result>
	</div>
<!--	<NewMaintenance ref="NewMaintenance" :systemType="systemType" :systemTypeId="systemTypeId" :systemTypeName="systemTypeName" ></NewMaintenance>-->
</div>
</template>
<script>
import * as lib from '@/util/lib.js'
import Checkbox from '@/components/common/ui/Checkbox.vue'
import Pagination from '@/components/common/ui/Pagination.vue'
import NoResult from '@/components/common/ui/NoResult'
import Loading from '@/components/common/ui/Loading'
import ViewDetail from '@/view/application/maintenance/part/ViewDetail'
import Confirm from '@/components/common/ui/Confirm.vue'
import {apiGetList,del} from '@/api/maintain/maintenance/list.js'
import NewMaintenance from '@/view/application/maintenance/part/NewMaintenance.vue'
let app
export default {
	name:'maintenanceList',
	components: {Checkbox, Pagination, NoResult, Loading,ViewDetail,Confirm,NewMaintenance},
	props: {
		searchText: {
				type: String,
				default: null
		 },
		systemType: {
				type: Number,
				default: 1
		},
		systemTypeId: {
				type: Number,
				default: null
		},
		systemTypeName:{
				type: String,
				default: null
		}
	},
	data(){
		return {
			stage,
				floatColumn: ['a', 'b'],
				column: ['1', '2', '3', '4', '5', '6', '7', '8', '9'],
			list: [],
			'orderDirection': this.$route.query.order || 'DESC', // DESC
					'orderProperty': this.$route.query.property || 'lastModifiedDate',
					pagination: {}, // 分页数据
					MaintenanceRecordQuery : {
						'name': null,
						'systemType':null,//维保系统类型
						'systemTypeId':null//维保系统ID
			},
				orderBy:'lastModifiedDate'
		}
	},
	methods:{
		operateModeChange: lib.operateModeChange,
		getLanguageStr,
		timeFormat: lib.timeFormat,
		getTypeText: lib.getTypeText,
		clickfount (item) {
			// onclick="statistic('A34','A3403')"
			if (this.$route.path.indexOf('application') !== -1) {
			statistic('A41', 'A4103')
		} else {
			statistic('A34', 'A3403')
		}
			this.$refs.ViewDetail.show(item)
		},
		confirmDel(id){
					this.$refs.confirm.show({
							text: getLanguageStr('app4', '确认要删除该维保记录吗？'),
							id: id
						})
			},
		onOrder (name, dir) { // 排序动作
				if (this.orderProperty == name) {
					if (dir == 'DESC') dir = 'ASC'
					else dir = 'DESC'
				}
				this.orderProperty = name
				this.orderDirection = dir
				this.orderBy=name
				this.getList()
			},
		searchKey () {
			this.$set(this.pagination.request, 'page', 1)
			this.MaintenanceRecordQuery.name = this.searchText;
			this.MaintenanceRecordQuery.systemType=this.systemType
			this.MaintenanceRecordQuery.systemTypeId=this.systemTypeId
			this.getList()
		},
		edit(data){
			this.$dynamic($(this.$el).parents("#app"),NewMaintenance,{
				systemType:this.systemType,
				systemTypeId:this.systemTypeId,
				systemTypeName:this.systemTypeName,
				powerTypeList:["PV"]
			},{}).then(({instance, childInstance})=>{
				childInstance.show(data,instance)
			})
		},
		del(data){
				del(data.id).then(res => {
						 this.$refs.ViewDetail.hide()
						this.getList();
					}, error => {
							!_.isEmpty(error) && this.$notify(error)
			})
		},
		getList (data) {
				this.$refs.Loading.show()
				if (data) this.$set(this.pagination.request, 'page', 1)
				let queryParam = {
						page: this.pagination.request.page,
						size: this.pagination.request.size,
						'order.direction':this.orderDirection,
						'order.property':this.orderProperty
				}
				let copyCond = Object.assign({}, this.MaintenanceRecordQuery)
				let copyCound = _.cloneDeep(copyCond)
				let queryData = {...copyCound, ...queryParam}
				apiGetList(queryData).then(success => {
						this.list = success.total ? success.data:null
				this.pagination.total = success.total
						let {total} = success
				this.pagination = {...this.pagination, ...{total}}
				this.$nextTick(()=>{
					lib.fillHeight();
					this.$refs.Loading.hide();
				})
				}, error => {
						!_.isEmpty(error) && this.$notify(error)
						this.$refs.Loading.hide()
				})
		},
	},
	mounted () {
		lib.fillHeight();
			lib.setScroll($(this.$el).find('[scroll]'));
			app = this
		},
}
</script>

<style lang="scss" scoped>
$operateMin:4em +2;
$operateMax:4em * 2 + 2;
.operate{
	>*{width:$operateMax;}
	&[mode]{width:$operateMax;}
	&[mode="min"]{width:$operateMin;
		&:hover{transform:translateX($operateMin - $operateMax);}
	}
}
</style>


// WEBPACK FOOTER //
// src/view/application/maintenance/part/List.vue